import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import ExchangeRateRevaluationList from "./ExchangeRateRevaluationList";

function ExchagereteRevalutionhead() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>Exchange Rate Revaluation List</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <ExchangeRateRevaluationList />
      </div>
    </div>
  );
}

export default ExchagereteRevalutionhead;